/* Studio Next — growth extras on top of the standard builder.
   1. Photo → Sticker: a solid photo gets a one-tap "cut out the subject" prompt
      (runs the builder's own cloud background removal + die-cut border).
   2. Packs: after a design goes in the cart, a bar shows the designs in the cart
      and starts the next design with the same size / finish / quantity.
   3. Approval: "Send for approval" shares the live design link; the reviewer can
      approve or ask for changes, and the designer sees the answer live. */
/* overlays live in #smnLayer, not directly in <body>: the builder CSS resets padding/transform/max-width on
   every direct body child, which breaks centred pop-ups */
window.smnLayer = window.smnLayer || function () { var l = document.getElementById('smnLayer'); if (!l) { l = document.createElement('div'); l.id = 'smnLayer'; document.body.appendChild(l); } return l; };
(function () {
  'use strict';
  var WORKER = 'https://print-api.stickermint.workers.dev';
  var PUBLIC_KEY = 'sm_print_a7x9K2mP4qR8wL3nvx920123';

  function start() {
    if (window._smxxStarted) return;
    window._smxxStarted = 1;
    var SMN = window.SMN, S = SMN.state;
    var toast = function (m, k, a) { (window.SMNX && window.SMNX.toast) ? window.SMNX.toast(m, k, a) : console.log(m); };
    var $ = function (s, r) { return (r || document).querySelector(s); };
    function h(html) { var d = document.createElement('div'); d.innerHTML = html.trim(); return d.firstChild; }
    function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
    function show(el) { el.hidden = false; el.style.removeProperty('display'); }

    /* ================= 1. Photo → Sticker ================= */
    var cutCard = h('<div class="smxx-cut" hidden role="dialog" aria-label="Turn this photo into a sticker">' +
      '<div class="smxx-cut-txt"><b>Turn this photo into a sticker?</b><span>We’ll cut out the subject and add a white die-cut border.</span></div>' +
      '<button type="button" class="smxx-cut-go">✂ Cut it out</button><button type="button" class="smxx-cut-no" aria-label="Keep the photo as it is">Keep as is</button></div>');
    var stageHost = $('.sms-preview') || document.body;
    stageHost.appendChild(cutCard);
    var askedFor = null;
    function isSolidPhoto(img) {
      try {
        var c = document.createElement('canvas'); c.width = c.height = 48;
        var x = c.getContext('2d'); x.drawImage(img, 0, 0, 48, 48);
        var d = x.getImageData(0, 0, 48, 48).data, clear = 0;
        for (var i = 3; i < d.length; i += 4) if (d[i] < 250) clear++;
        return clear < 48 * 48 * 0.01;
      } catch (e) { return false; }
    }
    setInterval(function () {
      var img = S.originalImg;
      if (!img || img === askedFor) { if (!img) cutCard.hidden = true; return; }
      if (!img.complete || !(img.naturalWidth || img.width)) return;
      askedFor = img;
      if (S.shape === 'die-cut' && S.bgMode === 'none' && isSolidPhoto(img) && $('.sms-tool-icon[data-bg="pro"]')) show(cutCard);
      else cutCard.hidden = true;
    }, 600);
    $('.smxx-cut-go', cutCard).onclick = function () {
      cutCard.hidden = true;
      var b = $('.sms-tool-icon[data-bg="pro"]');
      if (b) b.click();
    };
    $('.smxx-cut-no', cutCard).onclick = function () { cutCard.hidden = true; };

    /* ================= 2. Packs ================= */
    var packBar = h('<div class="smxx-pack" hidden><span class="smxx-pack-txt"></span>' +
      '<button type="button" class="smxx-pack-add">+ Add another design</button>' +
      '<a class="smxx-pack-cart" href="/cart">View cart</a></div>');
    (document.querySelector('.sms-config') || document.body).appendChild(packBar);
    var lastSpecs = null;
    async function refreshPack() {
      try {
        var cart = await (await fetch('/cart.js', { credentials: 'same-origin' })).json();
        var designs = cart.items.filter(function (it) { return it.properties && it.properties._studioItem === 'true'; });
        if (!designs.length) { packBar.hidden = true; return; }
        var total = designs.reduce(function (s, it) { return s + it.final_line_price; }, 0) / 100;
        $('.smxx-pack-txt', packBar).innerHTML = '<b>' + designs.length + ' design' + (designs.length > 1 ? 's' : '') + ' in your cart</b> · $' + total.toFixed(2);
        show(packBar);
      } catch (e) { /* cart unavailable — leave the bar alone */ }
    }
    // notice studio items being added (the builder posts to /cart/add.js)
    var _fetch = window.fetch;
    window.fetch = function (input, init) {
      var p = _fetch.apply(this, arguments);
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (/\/cart\/add(\.js)?$/.test(url.split('?')[0]) && init && typeof init.body === 'string' && init.body.indexOf('_studioItem') > -1) {
          lastSpecs = { size: S.size, finish: S.finish, qty: S.qty };
          p.then(function (r) { if (r.ok) setTimeout(refreshPack, 400); });
        }
      } catch (e) { /* never break the builder's own fetch */ }
      return p;
    };
    function clickIf(sel) { var el = document.querySelector(sel); if (el) { el.click(); return true; } return false; }
    $('.smxx-pack-add', packBar).onclick = function () {
      var keep = lastSpecs || { size: S.size, finish: S.finish, qty: S.qty };
      var drawer = document.querySelector('.scd-close, [data-cart-drawer-close], .sf-drawer__close');
      if (drawer && drawer.offsetParent) drawer.click();
      clickIf('#btnStartOver');
      setTimeout(function () {
        // put the previous design's specs back (Start over resets them to 2″ / matte / 50)
        var r = document.querySelector('.sms-sizes input[type=radio][value="' + keep.size + '"]');
        if (r) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); r.click(); }
        clickIf('.sms-finish-btn[data-finish="' + keep.finish + '"]');
        clickIf('.sms-qty-pre[data-qty="' + keep.qty + '"]');
        var f = document.getElementById('fileInput');
        if (f) f.click();
      }, 150);
    };
    refreshPack();

    /* ================= 3. Approval ================= */
    var params = new URLSearchParams(location.search);
    var sid = function () { return SMN.shareId && SMN.shareId(); };
    // approval record lives beside the design (ids are ≤16 chars; never reuse the design's own id)
    function apId(id) { return id.slice(0, 14) + 'ap'; }
    async function readApproval(id) {
      var r = await fetch(WORKER + '/share/' + apId(id) + '?t=' + Date.now());
      return r.ok ? r.json() : null;
    }
    async function writeApproval(id, rec) {
      rec.id = apId(id); rec.ts = Date.now();
      var r = await fetch(WORKER + '/share', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-API-Key': PUBLIC_KEY }, body: JSON.stringify(rec) });
      if (!r.ok) throw new Error('Could not send (' + r.status + ')');
    }

    // designer side: the "Send for approval" link under Add to cart
    var askLink = h('<button type="button" class="smxx-ask" hidden>Need a sign-off? <u>Send for approval</u></button>');
    var priceBox = $('.sms-price-box');
    if (priceBox) priceBox.appendChild(askLink);
    setInterval(function () { askLink.hidden = !(sid() && SMN.vo && SMN.vo().length); }, 1000);
    var watching = null, lastSeen = 0;
    askLink.onclick = async function () {
      var id = sid(); if (!id) return toast('Add a design first', 'warn');
      var u = new URL(location.href); u.searchParams.set('s', id); u.searchParams.set('approve', '1');
      var link = u.toString(), text = 'Can you approve this sticker design?';
      try { await writeApproval(id, { status: 'pending' }); } catch (e) { /* the link still works without the record */ }
      lastSeen = Date.now();
      if (navigator.share && matchMedia('(pointer:coarse)').matches) {
        navigator.share({ title: 'Sticker approval', text: text, url: link }).catch(function () {});
      } else {
        try { await navigator.clipboard.writeText(text + ' ' + link); toast('Approval link copied — send it to whoever signs off'); }
        catch (e) { window.prompt('Copy this approval link:', link); }
      }
      watch(id);
    };
    function watch(id) {
      if (watching === id) return;
      watching = id;
      setInterval(async function () {
        try {
          var rec = await readApproval(id);
          if (!rec || !rec.ts || rec.ts <= lastSeen || rec.status === 'pending') return;
          lastSeen = rec.ts;
          var who = rec.name ? esc(rec.name) : 'Your reviewer';
          if (rec.status === 'approved') toast('✅ ' + who + ' approved the design');
          else if (rec.status === 'changes') toast('✎ ' + who + ' asked for changes: “' + esc(rec.note || '') + '”', 'warn');
        } catch (e) { /* offline — try again next tick */ }
      }, 6000);
    }

    // reviewer side: ?approve=1
    if (params.get('approve') === '1' && params.get('s')) {
      var id0 = params.get('s');
      var bar = h('<div class="smxx-review" role="region" aria-label="Design approval">' +
        '<div class="smxx-review-txt"><b>You’ve been asked to approve this sticker</b><span>Check the design and size, then approve or ask for changes. Edits you make sync live.</span></div>' +
        '<div class="smxx-review-act"><button type="button" class="smxx-ok">✓ Approve</button><button type="button" class="smxx-chg">Ask for changes</button></div>' +
        '<form class="smxx-review-form" hidden><input name="name" placeholder="Your name (optional)" maxlength="60"><textarea name="note" placeholder="What should change?" maxlength="600" rows="2"></textarea><button type="submit">Send</button></form>' +
        '</div>');
      window.smnLayer().appendChild(bar);
      show(bar);
      var mode = 'approved';
      $('.smxx-ok', bar).onclick = function () { mode = 'approved'; var f = $('form', bar); f.note.hidden = true; show(f); f.name.focus(); $('button[type=submit]', f).textContent = 'Approve'; };
      $('.smxx-chg', bar).onclick = function () { mode = 'changes'; var f = $('form', bar); f.note.hidden = false; show(f); f.note.focus(); $('button[type=submit]', f).textContent = 'Send'; };
      $('form', bar).onsubmit = async function (e) {
        e.preventDefault();
        var f = e.target;
        if (mode === 'changes' && !f.note.value.trim()) { f.note.focus(); return; }
        try {
          await writeApproval(id0, { status: mode, name: f.name.value.trim().slice(0, 60), note: mode === 'changes' ? f.note.value.trim().slice(0, 600) : '' });
          $('.smxx-review-txt', bar).innerHTML = mode === 'approved'
            ? '<b>Approved ✓</b><span>The designer has been notified. Want to order it yourself? Use Add to cart.</span>'
            : '<b>Sent ✓</b><span>The designer will see your note right away.</span>';
          $('.smxx-review-act', bar).remove(); f.remove();
        } catch (err) { toast(err.message, 'warn'); }
      };
    }
  }

  function boot() { if (window.SMN) start(); else document.addEventListener('smn:ready', start, { once: true }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
